import { render, staticRenderFns } from "./FormImageItem.vue?vue&type=template&id=4a20fdaa&scoped=true"
import script from "./FormImageItem.vue?vue&type=script&lang=js"
export * from "./FormImageItem.vue?vue&type=script&lang=js"
import style0 from "./FormImageItem.vue?vue&type=style&index=0&id=4a20fdaa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a20fdaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-pharmacy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a20fdaa')) {
      api.createRecord('4a20fdaa', component.options)
    } else {
      api.reload('4a20fdaa', component.options)
    }
    module.hot.accept("./FormImageItem.vue?vue&type=template&id=4a20fdaa&scoped=true", function () {
      api.rerender('4a20fdaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TkCommonPage/components/tableComp/formItems/FormImageItem.vue"
export default component.exports